import _ from 'lodash';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { sqWorkbenchLayoutStore, sqWorkbenchStore, sqWorkbookStore } from '@/core/core.stores';
import { useFlux } from '@/core/hooks/useFlux.hook';
import { useFluxPath } from '@/core/hooks/useFluxPath.hook';
import { WorksheetPreferencesModal } from '@/header/WorksheetPreferencesModal.molecule';
import { setLayoutLocked } from '@/main/layout.actions';
import { doResetLayout } from '@/main/layout.utilities';
import { isWorksheet } from '@/main/routing.utilities';
import { isViewOnlyWorkbookMode } from '@/utilities/workbookMode.utilities';
import { Icon, TriggerWithDropdown } from '@seeqdev/qomponents';

export const LayoutControls = () => {
  const { t } = useTranslation();
  const [showWorksheetPreferencesModal, setShowWorksheetPreferencesModal] = useState(false);

  const layoutLocked = useFluxPath(sqWorkbenchLayoutStore, () => sqWorkbenchLayoutStore.layoutLocked);
  const { isTopic, acl } = useFlux(sqWorkbookStore);
  const { currentUser } = useFlux(sqWorkbenchStore);

  const isWorksheetOrViewOnly = isWorksheet() || isViewOnlyWorkbookMode();
  const isOwner = _.find(acl, (ace) => ace.identity?.id === currentUser.id)?.isOwner;
  const canSavePreferences = isWorksheetOrViewOnly && isOwner && !isTopic;

  const actions = [
    {
      href: '#',
      icon: 'fa-window-restore',
      onClick: doResetLayout,
      label: t('LAYOUT.RESET_LAYOUT'),
      testId: 'resetLayout',
    },
    {
      href: '#',
      icon: layoutLocked ? 'fa-lock-open' : 'fa-lock',
      label: layoutLocked ? t('LAYOUT.UNLOCK_LAYOUT') : t('LAYOUT.LOCK_LAYOUT'),
      onClick: () => {
        setLayoutLocked(!layoutLocked);
      },
      hasDivider: canSavePreferences,
      testId: 'lockLayout',
    },
    ...(canSavePreferences
      ? [
          {
            href: '#',
            icon: 'fa-sliders',
            label: t('USER.WORKSHEET_PREFERENCES'),
            onClick: () => setShowWorksheetPreferencesModal(true),
            testId: 'worksheetPreferences',
          },
        ]
      : []),
  ];

  return (
    <>
      <div
        className="ml5 flexColumnContainer cursorPointer flexNoGrowNoShrink flexAlignCenter"
        data-testid="layoutMenu">
        <TriggerWithDropdown
          tooltip={t('LAYOUT.CONFIGURE')}
          tooltipPlacement="bottom"
          dropdownItems={actions}
          triggerIcon={
            <Icon
              icon="fa-table-layout"
              iconPrefix="fa-regular"
              type="white"
              extraClassNames="fa-xlg flexNoGrowNoShrink mr5 sq-navbar-default"
            />
          }
        />
      </div>
      {showWorksheetPreferencesModal && (
        <WorksheetPreferencesModal onClose={() => setShowWorksheetPreferencesModal(false)} />
      )}
    </>
  );
};
